import React, { Fragment } from 'react';
import SunEditor from 'suneditor-react';
import lang from 'suneditor/src/lang'
import CodeMirror from 'codemirror'
import 'suneditor/dist/css/suneditor.min.css';
import 'codemirror/mode/htmlmixed/htmlmixed'
import 'codemirror/lib/codemirror.css'

const options = {
  lang:lang.es,
  height: 200,
  mode: "classic",
  codeMirror:CodeMirror,
    katex: "window.katex",
    videoFileInput: false,
    tabDisable: false,
    buttonList: [
      ["undo","redo"],
      ["fontSize","bold","italic","underline","strike","removeFormat"],
      ["outdent","indent","align","list"],
      // ["table","link","image"],
      ["preview","fullScreen"]
  ]
};

const Seccion = ({descripcion,setDescripcion}) =>{
 
  let handleChange = (content) =>{
    setDescripcion(content)
  }

  return(
    <Fragment>
      <SunEditor 
        setOptions={options}
        setContents={descripcion}
        onChange={handleChange}
      />
    </Fragment>
  )
}

export default  Seccion;
